export const GTM_ID = `GTM-ML23M35`;
export const INTERCOM_APP_ID = `ea5buymh`;
export const INTERCOM_INITIALIZE_DELAY = 5000;
export const __PROD__ = process.env.NODE_ENV === `production`;

function siteURL() {
  switch (process.env.NODE_CONTEXT) {
    case `production`:
      return `https://graphcms.com`;
    case `preview`:
      return `https://graphcms.com`;
    default:
      return `http://localhost:3000`;
  }
}

export const APP_URL = siteURL();
